import { http, isRequestCanceled } from "../utils/httpCommon";
import { useState, useEffect } from "react";

const useFetchData = (url) => {
  const [response, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const fetchData = async (signal) => {
    try {
      const res = await http.get(url, signal ? { signal } : undefined);
      setData(res.data.data);
      setLoading(false);
    } catch (error) {
      if (isRequestCanceled(error)) return;
      setError(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!url) {
      setData([]);
      setLoading(false);
      return;
    }
    const controller = new AbortController();
    fetchData(controller.signal);
    return () => controller.abort();
    // fetchData is recreated each render; url is the real input
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  const refetch = () => {
    fetchData();
  };

  return { response, error, refetch, loading, fetchData };
};

export default useFetchData;
